import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgArtifactNodeCard } from "../../../molecules/KgArtifactNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const ArtifactFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgArtifactNodeCard
      name={data.title ?? ""}
      kind={data.kind}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default ArtifactFlowNode;
